import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, ArrowRight } from "lucide-react";
import DashboardShell from "@/layouts/ProviderDashboardLayout";
import api from "@/lib/api";
import StatusPill from "@/components/marketplace/StatusPill";
import { useDocumentTitle } from "@/lib/useDocumentTitle";

export default function OrdersListPage() {
  const [role, setRole] = useState("customer");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useDocumentTitle("My orders");

  useEffect(() => {
    setLoading(true);
    api.get("/digital-orders/mine", { params: { role } }).then((r) => setItems(r.data || [])).catch(() => setItems([])).finally(() => setLoading(false));
  }, [role]);

  return (
    <DashboardShell>
      <div className="max-w-5xl">
        <div className="flex items-center justify-between mb-6">
          <div>
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#165a71]">Digital orders</div>
            <h1 className="mt-2 font-display text-2xl md:text-3xl font-semibold text-[#071b22]">Your orders</h1>
          </div>
          <select value={role} onChange={(e) => setRole(e.target.value)} className="rounded-full border border-slate-200 px-4 py-2 text-sm bg-white" data-testid="orders-role">
            <option value="customer">As customer</option>
            <option value="provider">As provider</option>
          </select>
        </div>
        {loading ? (
          <div className="text-[#252A34]/60">Loading…</div>
        ) : items.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-10 text-center">
            <div className="font-display text-lg text-[#071b22] font-semibold">No orders yet.</div>
            <div className="text-sm text-[#252A34]/70 mt-1">Hire digital talent to see orders here.</div>
            <Link to="/hire-digital" className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#165a71] text-white px-5 py-2.5 text-sm font-medium">Hire digital <ArrowRight className="h-4 w-4" /></Link>
          </div>
        ) : (
          <div className="grid gap-3">
            {items.map((o) => (
              <Link key={o.id} to={`/dashboard/orders/${o.id}`} className="rounded-2xl border border-slate-200 bg-white p-4 md:p-5 flex items-center gap-4 hover:border-[#165a71]/40 transition-colors" data-testid={`order-row-${o.id}`}>
                <div className="h-14 w-14 rounded-xl bg-[#165a71]/10 flex items-center justify-center text-[#165a71]"><Package className="h-5 w-5" /></div>
                <div className="min-w-0 flex-1">
                  <div className="font-display font-semibold text-[#071b22] truncate">{o.service_title || "Order"}</div>
                  <div className="text-xs text-[#252A34]/60 mt-1 flex flex-wrap items-center gap-2">
                    {o.due_date && <span>Due {new Date(o.due_date).toLocaleDateString()}</span>}
                    <span>· ${(o.total_estimate || 0).toFixed(2)}</span>
                    {o.is_milestone_project && <span>· {(o.milestones || []).length} milestones</span>}
                  </div>
                </div>
                <StatusPill status={o.status} />
              </Link>
            ))}
          </div>
        )}
      </div>
    </DashboardShell>
  );
}
